import React from 'react';

// App-request status → pill tone. Shared by ActiveAppsList and AppDetailPage.
export const APP_STATUS_TONE = {
  pending:           { bg: '#FEF3C7', fg: '#92400E', label: 'Pending' },
  approved:          { bg: '#DCFCE7', fg: '#166534', label: 'Approved' },
  provisioning:      { bg: '#DBEAFE', fg: '#1E40AF', label: 'Provisioning' },
  active:            { bg: '#CCFBF1', fg: '#0F766E', label: 'In progress' },
  publish_requested: { bg: '#FFE4CC', fg: '#9A3412', label: 'Publish requested' },
  published:         { bg: '#EDE9FE', fg: '#6D28D9', label: 'Published' },
  rejected:          { bg: '#FEE2E2', fg: '#991B1B', label: 'Rejected' },
};

export function StatusPill({ status }) {
  const tone = APP_STATUS_TONE[status] || APP_STATUS_TONE.pending;
  return (
    <span
      style={{
        fontSize: 12,
        fontWeight: 600,
        padding: '3px 10px',
        borderRadius: 999,
        background: tone.bg,
        color: tone.fg,
      }}
    >
      {tone.label}
    </span>
  );
}
